if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.parent = this.closest('.product-selection-wrapper');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      var datap = [];
      
      var custom_input = document.querySelector('.font_input');

      let size_dropdown =  this.parent.querySelector('.size-selection-option-wpr.option-size, .size-selection-option-wpr.option-sizes');
      if (size_dropdown && !size_dropdown.querySelector('input:checked')) {
        size_dropdown.classList.add('open');
        return false;
      }
      
      if(custom_input){
        if(custom_input.value){
          var items = {};
          var prop = {};
          items.id = document.querySelector('.init_name').value;
          items.quantity = 1;
          prop['Add up to 5 letters (Limit: 5)'] = custom_input.value;
          prop['Product Title'] = $('.font_input').attr('data-product_title') +' - '+ $('.font_input').attr('data-cur_var_title');
          items.properties = prop;
          datap.push(items);
        }
      }
      var items = {};
      items.id = this.form.querySelector('[name=id]').value;
      items.quantity = '1';
      datap.push(items);
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      var data = {
          items: datap
      };
      
      fetch(window.Shopify.routes.root+'cart/add.js', {
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      })
      .then(response => {
        console.log(response)
        return response.json();
      })
      .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {             
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
var divElement = document.getElementById('add-to-cart-button');
if(divElement != null){
  window.addEventListener('scroll', function() {
    
    var viewportHeight = window.innerHeight;
    var rect = divElement.getBoundingClientRect();
  
    if (rect.top < viewportHeight && rect.bottom >= 0) {
      divElement.classList.remove('viewed');
    } else {
      divElement.classList.add('viewed');
    }
  });
}